import { api } from "..";
import { DeleteMessagesBulkPayload, DeleteMessagesBulkResponse } from "./types";

export const deleteMessagesBulk = async (
  payload: DeleteMessagesBulkPayload
): Promise<DeleteMessagesBulkResponse> => {
  const { chatId, messageIds, scope } = payload;
  const res = await api.client.post(`/chats/${chatId}/messages/delete-many`, {
    messageIds,
    scope,
  });
  return res.data;
};
